import uploadssettingsheaddefaulticonfavicon2Png from "$lib/data/generated/uploads/settings/Head/defaultIcon/favicon 2.png";
import uploadssettingsheaddefaultimagetjMoorePreviewJpg from "$lib/data/generated/uploads/settings/Head/defaultImage/tj-moore-preview.jpg";

export const uploads = {
  "uploads/settings/Head/defaultIcon/favicon 2.png": uploadssettingsheaddefaulticonfavicon2Png,
  "uploads/settings/Head/defaultImage/tj-moore-preview.jpg": uploadssettingsheaddefaultimagetjMoorePreviewJpg
};